export default "__VITE_ASSET__Bli2Jh$e__"